import React, { createContext, useContext } from 'react'
import useDataGridPro from '../hooks/useDataGridPro'
import { useReactTable } from '@tanstack/react-table'
import { ValidRowModel } from './types'

type TableApiContextProps = ReturnType<typeof useDataGridPro<ValidRowModel>> & {
    table?: ReturnType<typeof useReactTable<ValidRowModel>> | null
}

const TableApiContext = createContext({} as TableApiContextProps)
export function useTableApiContext() {
    return useContext(TableApiContext)
}

export function TableApiProvider({
    children,
    ...props
}: TableApiContextProps & {
    children: React.ReactNode
}) {
    return (
        <TableApiContext.Provider value={props}>
            {children}
        </TableApiContext.Provider>
    )
}
